import React from "react";
import { Collapse, Flex } from "antd";
import { BookingAddOns, BookingTransactionDetails } from "../../interfaces/booking.interface";
import { currencyDisplay } from "../../utils/helpers";

const CARDS = ["visa", "mastercard"];

const PricingSummary = (
  props: {
    header: string;
    summary: BookingTransactionDetails;
    ccRate?: number; //used in Booking Form
    serviceFee?: string; //used in Payment Status
    paymentMethod: string;
    addOns?: BookingAddOns[];
    refNo?: string;
    showBalance?: boolean;
  }
) => {
  const {
    header,
    summary,
    ccRate,
    paymentMethod,
    addOns = [],
    serviceFee,
    refNo,
    showBalance = false
  } = props;
  let grandTotal = summary?.fareBreakdown?.total || 0, 
      currency_grandTotal = "", showAdminFee = CARDS.includes(paymentMethod), currency_adminFee = serviceFee, currency_addOnsTotal= "";

  if(summary != null){  
    const addOnsTotal = addOns.reduce((sum, addon) => sum + addon.value, 0);
    currency_addOnsTotal = currencyDisplay(summary?.priceCurrency, addOnsTotal.toFixed(2));
    grandTotal = grandTotal + addOnsTotal;

    if(ccRate != undefined){    
      if(showAdminFee && ccRate > 0){
        const adminFee = Number(grandTotal * ccRate);
        currency_adminFee = currencyDisplay(summary.priceCurrency, adminFee.toFixed(2));
        grandTotal = grandTotal + adminFee;
      }
    }

    currency_grandTotal = currencyDisplay(summary.priceCurrency, grandTotal.toFixed(2));
  }
  


  // Build add-ons collapse items
  const addOnsCollapseItems = addOns.length > 0 ? [{
    key: 'add-ons',
    label: (
      <div className="pricing-summary-booking-details-items" style={{ width: '100%' }}>
        <span>Add ons</span>
        <span>+ {currency_addOnsTotal}</span>
      </div>
    ),
    children: (
      <div className="pricing-summary-addons-details">
        {addOns.map((addon, index) => (
          <div key={index} className="pricing-summary-booking-details-items">
            <span>{addon.label} x {addon.totalPax}</span>
            <span>+ {currencyDisplay(summary?.priceCurrency, addon.value.toFixed(2))}</span>
          </div>
        ))}
      </div>
    )
  }] : [];


  return (
    <div className="pricing-summary">
      {header && <h5>{header}</h5>}

      <Flex gap={20} wrap vertical className="pricing-summary-booking-details">
        <div className="pricing-summary-booking-details-tour">
          {
            refNo && (
              <>
                <label>Reference No.</label>
                <span> {refNo}  </span>
              </>
            )
          }

          <label>Tour</label>
          <span> {summary?.tourName}  </span>

          <label>Tour Code</label>
          <div><span> {summary?.tourCode} </span> <span id="tour-country"> {summary?.country} </span></div>

          <label>Departure Date</label>
          <span> {summary?.departureDate} </span>
        </div>
          {
            summary?.fareBreakdown?.items?.length > 0 && (
              <div className="pricing-summary-booking-details-breakdown">
                <label>Fare Breakdown</label>
                <span className="type">{summary?.fareBreakdown.promo}</span>
                {
                  summary?.fareBreakdown?.items.map((item: { category: string; count: number; sum: number }, index) => (
                    item.category && (    
                        <div key={index} className="pricing-summary-booking-details-items">
                          <span> {item.category} x {item.count} </span>
                          <span>{currencyDisplay(summary.priceCurrency, item.sum)}</span>
                        </div>
                    )
                  ))
                }

                {
                  addOnsCollapseItems.length > 0 && (
                    <Collapse 
                      items={addOnsCollapseItems}
                      accordion
                      bordered={false}
                      className=""
                    />
                  )
                }


                {
                  (showAdminFee) && (
                    <div className="pricing-summary-booking-details-items">
                      <span>Admin Fee</span>
                      <span>{currency_adminFee} </span>
                    </div>
                  )
                }
                <div className="pricing-summary-booking-details-total">
                  <span>Grand Total</span>
                  <span>{currency_grandTotal}</span>
                </div>

                {
                  showBalance && (
                    <>
                      <div className="pricing-summary-booking-details-items">
                        <span>Deposit paid</span>
                        <span>-{summary?.currencyDeposit} </span>
                      </div>

                      <div className="pricing-summary-booking-details-items remaining-balance">
                        <span>Remaining balance</span>
                        <span> <b>{summary?.currencyBalance} </b></span>
                      </div>
                    </>
                  )
                }


              </div>
            )
          }    
      </Flex>
    </div>
  )
}

export default PricingSummary;